export const acceptedFileFormats = ['.geojson', '.json', '.shp'];
